import { createAction, props } from '@ngrx/store';

import {
  ServiceError,
  NavigationItem,
  LogoutVariations,
} from '@cigna/chcp/shared/util';

export const headerNavLoad = createAction('[Shell] Header Nav Load');
export const headerNavLoadSuccess = createAction(
  '[Shell] Header Nav Load Success',
  props<{ navItems: NavigationItem[] }>(),
);
export const headerNavLoadError = createAction(
  '[Shell] Header Nav Load Error',
  props<{ error: ServiceError }>(),
);
export const siteNavLoad = createAction('[Shell] Site Nav Load');
export const siteNavLoadSuccess = createAction(
  '[Shell] Site Nav Load Success',
  props<{ navItems: NavigationItem[] }>(),
);
export const siteNavLoadError = createAction(
  '[Shell] Site Nav Load Error',
  props<{ error: ServiceError }>(),
);

export const loginStepup = createAction('[Shell] Login Stepup');
export const loginStepupSuccess = createAction(
  '[Shell] Login Stepup Sucess',
  props<{ location: string }>(),
);
export const loginStepupError = createAction('[Shell] Login Stepup Error');

export const logout = createAction(
  '[Shell] LogOut',
  props<{ variation: LogoutVariations; linkName: string }>(),
);
export const reset = createAction('[Shell] Reset All Stores to Initial State');

export const wamApprovalStatusLoad = createAction(
  '[Shell] WAM Approval Status Load',
);
export const wamApprovalStatusLoadSuccess = createAction(
  '[Shell] WAM Approval Status Load Success',
  props<{ status: string }>(),
);
export const wamApprovalStatusLoadError = createAction(
  '[Shell] WAM Approval Status Load Error',
);
